<template>
  <div class="app-conf-group-page">
    <div class="global-header-wrap">
      <div class="header-left">
        <div class="left-part">
          <span>分组名称</span>
          <div class="listSearch">
            <el-input
              v-model="name"
              clearable
              @input="inputHandleSeach"
              @keyup.enter.native="search"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>设备型号</span>
          <div class="listSearch">
            <el-input
              v-model="model"
              clearable
              @input="inputHandleSeach"
              @keyup.enter.native="search"
              :placeholder="$t('placeholder.enter')"
            >
            </el-input>
          </div>
        </div>
        <div class="left-part">
          <span>状态</span>
          <div class="listSearch">
            <el-select
              v-model="status"
              clearable
              @change="search"
              placeholder="请选择"
            >
              <el-option label="全部" value=""></el-option>
              <el-option label="正常" value="0"></el-option>
              <el-option label="已禁用" value="1"></el-option>
            </el-select>
          </div>
        </div>
        <button class="global-button-style" @click="search()">
          {{ $t("commonMsg.search") }}
        </button>
        <button
          class="global-button-style"
          style="margin-left: 10px"
          @click="showCreateDialog"
        >
          创建配置分组
        </button>
      </div>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div slot="header">配置分组总数：{{ total ? total : 0 }}</div>
      <div class="global-body-wrap">
        <AppTable
          :tableProps="tableProps"
          :tableData="tableData"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination
        :pageSize="paramsList.limit"
        :total="total"
        @pageNum="pageNum"
        @pageSize="pageSize"
      />
    </el-card>

    <!-- 创建/编辑弹窗 -->
    <el-dialog
      :title="isEdit ? '编辑配置分组' : '创建配置分组'"
      :visible.sync="editDialogVisible"
      width="600px"
    >
      <el-form :model="editForm" label-width="120px">
        <el-form-item label="分组名称" required>
          <el-input
            v-model="editForm.name"
            placeholder="请输入分组名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="支持型号" required>
          <el-select
            v-model="editForm.models"
            multiple
            filterable
            allow-create
            placeholder="请选择或输入设备型号"
            style="width: 100%"
          >
            <el-option label="Note Air3" value="Note Air3"></el-option>
            <el-option label="Tab Ultra" value="Tab Ultra"></el-option>
            <el-option label="Note Air2" value="Note Air2"></el-option>
            <el-option label="Tab Ultra C" value="Tab Ultra C"></el-option>
            <el-option label="Tab X" value="Tab X"></el-option>
            <el-option label="Nova Air C" value="Nova Air C"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            type="textarea"
            v-model="editForm.description"
            :rows="3"
            placeholder="请输入分组描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="editForm.status">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">确定</el-button>
      </span>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog
      title="配置分组详情"
      :visible.sync="detailDialogVisible"
      width="600px"
    >
      <div v-if="currentDetail" class="detail-content">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="detail-item">
              <span class="label">分组名称:</span>
              <span class="value">{{ currentDetail.name }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="detail-item">
              <span class="label">支持型号:</span>
              <span class="value">{{
                currentDetail.models && currentDetail.models.length > 0
                  ? currentDetail.models.join(", ")
                  : "-"
              }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="detail-item">
              <span class="label">描述:</span>
              <span class="value">{{ currentDetail.description || "-" }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">状态:</span>
              <span class="value">{{
                currentDetail.status === 0 ? "正常" : "已禁用"
              }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">创建时间:</span>
              <span class="value">{{
                formatDate(currentDetail.createdAt)
              }}</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="detail-item">
              <span class="label">更新时间:</span>
              <span class="value">{{
                formatDate(currentDetail.updatedAt)
              }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 管理型号弹窗 -->
    <el-dialog
      title="管理分组型号"
      :visible.sync="modelsDialogVisible"
      width="600px"
    >
      <el-form label-width="120px">
        <el-form-item label="当前型号">
          <div v-if="currentModels && currentModels.length > 0">
            <el-tag
              v-for="model in currentModels"
              :key="model"
              closable
              @close="removeModel(model)"
              style="margin-right: 10px; margin-bottom: 10px"
            >
              {{ model }}
            </el-tag>
          </div>
          <div v-else style="color: #909399">暂无型号</div>
        </el-form-item>
        <el-form-item label="添加型号">
          <el-select
            v-model="newModels"
            multiple
            filterable
            allow-create
            placeholder="请选择或输入设备型号"
            style="width: 100%"
          >
            <el-option label="Note Air3" value="Note Air3"></el-option>
            <el-option label="Tab Ultra" value="Tab Ultra"></el-option>
            <el-option label="Note Air2" value="Note Air2"></el-option>
            <el-option label="Tab Ultra C" value="Tab Ultra C"></el-option>
            <el-option label="Tab X" value="Tab X"></el-option>
            <el-option label="Nova Air C" value="Nova Air C"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modelsDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="addModels">添加型号</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";

export default {
  name: "appConfGroup",
  components: {
    AppTable,
    Pagination,
  },
  computed: {
    ...mapGetters(["addPopup"]),
    tableProps() {
      let tableProps = [
        {
          prop: "name",
          label: "分组名称",
          width: 200,
        },
        {
          prop: "modelsDisplay",
          label: "支持型号",
          width: 250,
        },
        {
          prop: "description",
          label: "描述",
          width: 450,
        },
        {
          prop: "statusDisplay",
          label: "状态",
          width: 80,
        },
        {
          prop: "createdAt",
          label: "创建时间",
          width: 180,
        },
        {
          prop: "handle",
          label: "操作",
          btn: [
            this.$t("commonMsg.checkDetails"),
            this.$t("commonMsg.edit"),
            // "管理型号",
            // "禁用",
            this.$t("commonMsg.del"),
          ],
        },
      ];
      return tableProps;
    },
  },
  data() {
    return {
      tableData: [],
      total: 0,
      name: "",
      model: "",
      status: "",
      paramsList: { limit: 20, page: 1 },
      timer: null,
      editDialogVisible: false,
      detailDialogVisible: false,
      modelsDialogVisible: false,
      isEdit: false,
      editForm: {
        name: "",
        models: [],
        description: "",
        status: 0,
      },
      editId: null,
      currentDetail: null,
      currentModels: [],
      newModels: [],
      manageGroupId: null,
    };
  },
  methods: {
    async getGroupList() {
      try {
        let res = await this.$http.getAppConfGroupList(this.paramsList);
        this.total = res.data.count;
        // 处理显示数据
        this.tableData = res.data.results.map(item => ({
          ...item,
          modelsDisplay: item.models && item.models.length > 0 ? item.models.join(", ") : "-",
          statusDisplay: item.status === 0 ? "正常" : "已禁用"
        }));
      } catch (error) {
        console.error(error);
      }
    },

    search() {
      this.paramsList.page = 1;
      this.name
        ? (this.paramsList.name = this.name)
        : delete this.paramsList.name;
      this.model
        ? (this.paramsList.model = this.model)
        : delete this.paramsList.model;
      this.status !== ""
        ? (this.paramsList.status = this.status)
        : delete this.paramsList.status;

      this.getGroupList();
    },

    inputHandleSeach() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.search();
      }, 1000);
    },

    showCreateDialog() {
      this.isEdit = false;
      this.editForm = {
        name: "",
        models: [],
        description: "",
        status: 0,
      };
      this.editDialogVisible = true;
    },

    async tableHandle(obj) {
      const row = obj.data.row;
      const type = obj.type;

      if (type === this.$t("commonMsg.checkDetails")) {
        await this.showDetail(row._id);
      } else if (type === this.$t("commonMsg.edit")) {
        await this.showEdit(row._id);
      } else if (type === "管理型号") {
        await this.showManageModels(row._id);
      } else if (type === "禁用") {
        const newStatus = row.status === 0 ? 1 : 0;
        const action = newStatus === 1 ? "禁用" : "启用";
        this.$confirm(`确定要${action}此分组吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          await this.toggleStatus(row._id, newStatus);
        });
      } else if (type === this.$t("commonMsg.del")) {
        this.$confirm("确定要删除此分组吗?删除后不可恢复！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          await this.deleteGroup(row._id);
        });
      }
    },

    async showDetail(id) {
      try {
        let res = await this.$http.getAppConfGroupDetail(id);
        this.currentDetail = res.data;
        this.detailDialogVisible = true;
      } catch (error) {
        this.elMsg("获取详情失败", "error");
      }
    },

    async showEdit(id) {
      try {
        let res = await this.$http.getAppConfGroupDetail(id);
        const detail = res.data;

        this.isEdit = true;
        this.editForm = {
          name: detail.name || "",
          models: detail.models || [],
          description: detail.description || "",
          status: detail.status || 0,
        };
        this.editId = id;
        this.editDialogVisible = true;
      } catch (error) {
        this.elMsg("获取分组信息失败", "error");
      }
    },

    async submitEdit() {
      if (!this.editForm.name) {
        this.elMsg("请输入分组名称", "warning");
        return;
      }
      if (!this.editForm.models || this.editForm.models.length === 0) {
        this.elMsg("请选择支持型号", "warning");
        return;
      }

      try {
        if (this.isEdit) {
          await this.$http.updateAppConfGroup(this.editId, this.editForm);
          this.elMsg("编辑成功", "success");
        } else {
          await this.$http.createAppConfGroup(this.editForm);
          this.elMsg("创建成功", "success");
        }
        this.editDialogVisible = false;
        this.getGroupList();
      } catch (error) {
        this.elMsg(this.isEdit ? "编辑失败" : "创建失败", "error");
      }
    },

    async toggleStatus(id, status) {
      try {
        await this.$http.toggleAppConfGroupStatus(id, { status });
        this.getGroupList();
        this.elMsg(status === 0 ? "启用成功" : "禁用成功", "success");
      } catch (error) {
        this.elMsg(status === 0 ? "启用失败" : "禁用失败", "error");
      }
    },

    async deleteGroup(id) {
      try {
        await this.$http.deleteAppConfGroup(id);
        this.getGroupList();
        this.elMsg("删除成功", "success");
      } catch (error) {
        this.elMsg("删除失败", "error");
      }
    },

    async showManageModels(id) {
      try {
        let res = await this.$http.getAppConfGroupDetail(id);
        this.currentModels = res.data.models || [];
        this.newModels = [];
        this.manageGroupId = id;
        this.modelsDialogVisible = true;
      } catch (error) {
        this.elMsg("获取分组信息失败", "error");
      }
    },

    async addModels() {
      if (!this.newModels || this.newModels.length === 0) {
        this.elMsg("请选择要添加的型号", "warning");
        return;
      }

      try {
        await this.$http.addModelsToGroup(this.manageGroupId, {
          models: this.newModels,
        });
        this.elMsg("添加型号成功", "success");
        // 刷新当前型号列表
        let res = await this.$http.getAppConfGroupDetail(this.manageGroupId);
        this.currentModels = res.data.models || [];
        this.newModels = [];
        this.getGroupList();
      } catch (error) {
        this.elMsg("添加型号失败", "error");
      }
    },

    async removeModel(model) {
      this.$confirm(`确定要从分组中移除型号 ${model} 吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          await this.$http.removeModelsFromGroup(this.manageGroupId, {
            models: [model],
          });
          this.elMsg("移除型号成功", "success");
          // 刷新当前型号列表
          let res = await this.$http.getAppConfGroupDetail(
            this.manageGroupId
          );
          this.currentModels = res.data.models || [];
          this.getGroupList();
        } catch (error) {
          this.elMsg("移除型号失败", "error");
        }
      });
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleString("zh-CN");
    },

    pageNum(val) {
      this.paramsList.page = val;
      this.getGroupList();
    },

    pageSize(size) {
      this.paramsList.limit = size;
      this.getGroupList();
    },
  },
  mounted() {
    this.getGroupList();
  },
};
</script>

<style lang="scss" scoped>
.global-header-wrap {
  padding: 10px 44px;
}
.global-button-style {
  margin-top: 20px;
  margin-left: 0;
}
.app-conf-group-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .app-table-container {
    flex: 1;
    overflow: hidden;
  }
  
  .global-body-wrap {
    height: calc(100vh - 280px);    
    #table-wrap {
      height: 100%;
    }  }
  
  .header-left {
    width: 100%;
    float: left;
  }
  .left-part {
    float: left;
    margin-right: 20px;
    .listSearch {
      .el-input {
        width: 180px;
      }
      .el-select {
        width: 180px;
      }
    }
    > span {
      margin-right: 10px;
      font-size: 14px;
    }
  }
}

.detail-content {
  .detail-item {
    margin-bottom: 15px;
    display: flex;
    align-items: flex-start;
    .label {
      font-weight: bold;
      min-width: 100px;
      color: #606266;
    }
    .value {
      flex: 1;
      color: #303133;
    }
  }
}
</style>
